// extracted by mini-css-extract-plugin
module.exports = {"ApplianceRatings":"ApplianceRatings_ApplianceRatings__WwnNy"};